export function formatNumbersWithCommas(number){
    return number.toLocaleString()
}